module.exports = __webpack_public_path__ + "img/9.de8f484c.png";